import { cn } from "../../../../../src/utils/shadcn";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowRightWhiteIcon,
  ArrowLeftWhiteIcon,
} from "../../../../common/icons";
import type { CarouselNavigationProps } from "./interface";

export function CarouselNavigation({
  isDisabled,
  direction,
  onClick,
  navigationNextBtnClassName,
  navigationPrevBtnClassName,
  isWhite = false, // Add this prop to determine the icon variant
}: CarouselNavigationProps & { isWhite?: boolean }) {
  const disabledClasses = cn(isDisabled && "pointer-events-none");

  return (
    <div
      className={cn(
        "inline-flex h-8 w-8 cursor-pointer items-center justify-center rounded-full  text-base text-accent-1000 transition-colors hover:bg-accent-200 md:h-[40px] md:w-[40px]",
        direction === "prev" && "left-10",
        direction === "next" && "right-10",
        isDisabled && "cursor-not-allowed opacity-90",
        direction === "prev" && navigationPrevBtnClassName,
        direction === "next" && navigationNextBtnClassName,
      )}
      onClick={onClick}
    >
      {direction === "prev" ? (
        isWhite ? (
          <ArrowLeftWhiteIcon className={disabledClasses} />
        ) : (
          <ArrowLeftIcon className={disabledClasses} />
        )
      ) : isWhite ? (
        <ArrowRightWhiteIcon className={disabledClasses} />
      ) : (
        <ArrowRightIcon className={disabledClasses} />
      )}
    </div>
  );
}
